import { Box, Divider, FormField, RadioGroup, Text } from '@wix/design-system';
import React, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import { LTRIcon, RTLIcon } from 'wix-rich-content-plugin-commons';
import { ToggleButton, ThumbnailPicker } from 'wix-rich-content-ui-components';
import { s as styleInject } from '../../style-inject.es-e7b07dd7.js';
import { COLLAPSIBLE_LIST_EXPANDED_DEFAULT, COLLAPSIBLE_LIST_ONE_PAIR_EXPANDED } from '../../dataHooks.js';
import { listDirection, initialExpandedItems, COLLAPSIBLE_LIST_TYPE } from '../../types.js';

var css_248z = ".GkobH{color:#fff}";
var classes = {"link":"GkobH"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const CollapsibleListSettings = ({
  onChange,
  value,
  pluginEvents,
  isQapageDataEnabled
}) => {
  const { t } = useContext(RicosContext);
  const ExpandOptions = () => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    FormField,
    {
      label: t("CollapsibleList_CollapsibleListSettings_Tab_Settings_CollapseView_Title")
    },
    /* @__PURE__ */ React.createElement(
      RadioGroup,
      {
        value: value.initialExpanded.type,
        onChange: (changedValue) => {
          const newValue = changedValue === "ALL" ? {
            initialExpanded: { type: "ALL" }
          } : {
            initialExpanded: {
              type: changedValue,
              expandOnlyOne: value.initialExpanded.type !== "ALL" ? value.initialExpanded.expandOnlyOne : false
            }
          };
          onChange(__spreadValues(__spreadValues({}, value), newValue));
        }
      },
      /* @__PURE__ */ React.createElement(
        RadioGroup.Radio,
        {
          value: initialExpandedItems.ALL,
          dataHook: COLLAPSIBLE_LIST_EXPANDED_DEFAULT.ALL
        },
        /* @__PURE__ */ React.createElement(Text, { size: "small" }, t("CollapsibleList_CollapsibleListSettings_Tab_Settings_CollapseView_Expanded"))
      ),
      /* @__PURE__ */ React.createElement(
        RadioGroup.Radio,
        {
          value: initialExpandedItems.FIRST,
          dataHook: COLLAPSIBLE_LIST_EXPANDED_DEFAULT.FIRST
        },
        /* @__PURE__ */ React.createElement(Text, { size: "small" }, t("CollapsibleList_CollapsibleListSettings_Tab_Settings_CollapseView_FirstExpanded"))
      ),
      /* @__PURE__ */ React.createElement(
        RadioGroup.Radio,
        {
          value: initialExpandedItems.NONE,
          dataHook: COLLAPSIBLE_LIST_EXPANDED_DEFAULT.NONE
        },
        /* @__PURE__ */ React.createElement(Text, { size: "small" }, t("CollapsibleList_CollapsibleListSettings_Tab_Settings_CollapseView_Collapsed"))
      )
    )
  ), value.initialExpanded.type !== initialExpandedItems.ALL && /* @__PURE__ */ React.createElement(
    ToggleButton,
    {
      checked: !!value.initialExpanded.expandOnlyOne,
      title: t("CollapsibleList_CollapsibleListSettings_Tab_Settings_CollapseView_InSections"),
      dataHook: COLLAPSIBLE_LIST_ONE_PAIR_EXPANDED,
      onChange: () => {
        const expandOnlyOne = value.initialExpanded.type === "ALL" ? false : value.initialExpanded.expandOnlyOne;
        onChange(__spreadProps(__spreadValues({}, value), {
          initialExpanded: {
            type: value.initialExpanded.type,
            expandOnlyOne: !expandOnlyOne
          }
        }));
      }
    }
  ));
  const dataSource = [
    {
      value: listDirection.LTR,
      label: t("CollapsibleList_CollapsibleListSettings_Tab_Settings_Direction_LTR"),
      icon: LTRIcon,
      dataHook: "ltrDirection"
    },
    {
      value: listDirection.RTL,
      label: t("CollapsibleList_CollapsibleListSettings_Tab_Settings_Direction_RTL"),
      icon: RTLIcon,
      dataHook: "rtlDirection"
    }
  ];
  const DirectionOptions = () => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    ThumbnailPicker,
    {
      dataSource: dataSource.map((item) => ({
        value: item.value,
        dataHook: item.dataHook,
        renderBackgroundImage: (props) => /* @__PURE__ */ React.createElement(item.icon, __spreadValues({}, props)),
        label: item.label
      })),
      selectedValue: value.direction,
      title: t("CollapsibleList_CollapsibleListSettings_Tab_Settings_Direction_Title"),
      titleInfoContent: t(
        "CollapsibleList_CollapsibleListSettings_Tab_Settings_Direction_Title_Tooltip"
      ),
      onChange: (direction) => {
        onChange(__spreadProps(__spreadValues({}, value), { direction }));
      }
    }
  ));
  const QaPageToggle = () => {
    const onToggle = () => {
      var _a;
      (_a = pluginEvents == null ? void 0 : pluginEvents.onChangePluginSettings) == null ? void 0 : _a.call(pluginEvents, {
        pluginId: COLLAPSIBLE_LIST_TYPE,
        actionName: "QapageData",
        value: value.isQapageData ? "no" : "yes"
      });
      onChange(__spreadProps(__spreadValues({}, value), { isQapageData: !value.isQapageData }));
    };
    return /* @__PURE__ */ React.createElement(
      ToggleButton,
      {
        checked: value.isQapageData,
        title: t("CollapsibleList_CollapsibleListSettings_Tab_Settings_FAQ_Enabled_Toggle"),
        dataHook: "isQapageDataToggle",
        onChange: onToggle,
        infoContent: /* @__PURE__ */ React.createElement(React.Fragment, null, t("CollapsibleList_CollapsibleListSettings_Tab_Settings_FAQ_Enabled_Tooltip"), " ", /* @__PURE__ */ React.createElement(
          "a",
          {
            href: "https://wix.wixanswers.com/app/kb/article/a5b1247b-baf3-4baa-a7f1-7137e10ca768/en/",
            target: "_blank",
            rel: "noreferrer",
            className: classes.link
          },
          t("LinkPanel_Learn_More_Label")
        ))
      }
    );
  };
  return /* @__PURE__ */ React.createElement(Box, { direction: "vertical", gap: "SP3" }, /* @__PURE__ */ React.createElement(ExpandOptions, null), isQapageDataEnabled && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Divider, null), /* @__PURE__ */ React.createElement(QaPageToggle, null)), /* @__PURE__ */ React.createElement(Divider, null), /* @__PURE__ */ React.createElement(DirectionOptions, null));
};

export { CollapsibleListSettings };
//# sourceMappingURL=CollapsibleListSettings.js.map
